import ajax from '@/utils/ajax';
import requestUrls from '@/assets/js/requestUrls';

// 查询优惠券详情
export const reqServiceTime = () => (ajax(requestUrls.reqServiceTimeUrl));// 获取服务器时间
export function reqReceiveCoupon() {
  return fetch(requestUrls.reqReceiveCouponUrl);
}
